import React, { useContext, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { useIsSideNavCollapsed } from '@confluence/page-layout-side-navigation-context/entry-points/SideNavigationCollapsedStore.ts';
// eslint-disable-next-line no-restricted-imports -- deprecated - use RouteState instead
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { SpaceSettingsSideNavigation } from '@confluence/space-settings';
import { useSpaceKey } from '@confluence/space-utils/entry-points/useSpaceKey.ts';

const SpaceAdminNavigationInternal = () => {
	const spaceAlias = useSpaceKey();

	const isCollapsed = useIsSideNavCollapsed();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { location, matchRoute } = useContext(RoutesContext);
	const route = matchRoute(location?.pathname || '');
	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'spaceAdminSideNavigation',
				attributes: {
					tab: route?.name || '',
					isVisible: !isCollapsed,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, isCollapsed, route?.name]);

	return <SpaceSettingsSideNavigation spaceAlias={spaceAlias || ''} />;
};

export const SpaceAdminNavigation = (props: any): React.JSX.Element => (
	<ErrorBoundary attribution={Attribution.ADMIN_EXPERIENCE}>
		<SpaceAdminNavigationInternal {...props} />
	</ErrorBoundary>
);
